export default "__VITE_ASSET__6c52048b__"